// icons
import bowtieIcon from "./images/icons/intersections/bowtie.png";
import centerTurnOverpassIcon from "./images/icons/intersections/centerTurnOberpass.png";
import continuousGreenTIcon from "./images/icons/intersections/contGreenT.png";
import contraflowLeftIcon from "./images/icons/intersections/contraLeft.png";
import conventionalSignalIcon from "./images/icons/intersections/conventional.png";
import divergingDiamondIcon from "./images/icons/intersections/DDI.png";
import doubleRoundaboutIcon from "./images/icons/intersections/doubleRound.png";
import echelonIcon from "./images/icons/intersections/echelon.png";
import fullDisplacedLeftTurnIcon from "./images/icons/intersections/DLT.png";
// import michiganUrbanDiamondIcon from "./images/icons/intersections/mich-urban-diamond.png";
import MUTIcon from "./images/icons/intersections/MUT.png";
import partialCloverleafIcon from "./images/icons/intersections/partial-cloverleaf.png";
import quadrantRoadwayIcon from "./images/icons/intersections/QR.png";
import RCUTIcon from "./images/icons/intersections/RCUT.png";
import roundaboutIcon from "./images/icons/intersections/roundabout.png";
// import singleLoopIcon from "./images/icons/intersections/single-loop.png";
import singlePointInterchangeIcon from "./images/icons/intersections/sinlge-point-urban.png";
import singleRdbtInterchangeIcon from "./images/icons/intersections/single-roundabout.png";
import splitIcon from "./images/icons/intersections/split-intersection.png";
// import thruCutIcon from "./images/icons/intersections/thruCut.png";
import traditionalDiamondIcon from "./images/icons/intersections/diamond.png";

// diagrams
import bowtieDiagram from "./images/diagrams/Bowtie.jpg";
import centerTurnOverpassDiagram from "./images/diagrams/CenterTurnOverpass.jpg";
import continuousGreenTDiagram_N from "./images/diagrams/ContinuousGreenT_N.jpg";
import continuousGreenTDiagram_W from "./images/diagrams/ContinuousGreenT_W.jpg";
import continuousGreenTDiagram_E from "./images/diagrams/ContinuousGreenT_E.jpg";
import continuousGreenTDiagram_S from "./images/diagrams/ContinuousGreenT_S.jpg";
import contraflowLeftDiagram from "./images/diagrams/ContraflowLeft.png";
import conventionalSignalDiagram from "./images/diagrams/ConventionalSignal.png";
import divergingDiamondDiagram from "./images/diagrams/DivergingDiamond.jpg";
import DLTInterchangeDiagram from "./images/diagrams/DLTInterchange.png";
import doubleRoundaboutDiagram from "./images/diagrams/DoubleRoundabout.jpg";
import echelonDiagram from "./images/diagrams/Echelon.png";
import fullDisplacedLeftTurnDiagram from "./images/diagrams/FullDisplacedLeftTurn.jpg";
// import michiganUrbanDiamondDiagram from "./images/diagrams/MichiganUrbanDiamond.jpg";
import MUTDiagram from "./images/diagrams/MUT.png";
import partialCloverleafADiagram from "./images/diagrams/PartialCloverleafA.jpg";
import partialCloverleafBDiagram from "./images/diagrams/PartialCloverleafB.jpg";
import partialDLTDiagram from "./images/diagrams/PartialDLT.jpg";
import partialMUTDiagram from "./images/diagrams/PartialMUT.png";
import quadrantRoadwayNEDiagram from "./images/diagrams/QuadrantRoadwayNE.jpg";
import quadrantRoadwayNWDiagram from "./images/diagrams/QuadrantRoadwayNW.jpg";
import quadrantRoadwaySEDiagram from "./images/diagrams/QuadrantRoadwaySE.jpg";
import quadrantRoadwaySWDiagram from "./images/diagrams/QuadrantRoadwaySW.jpg";
import RCUTDiagram from "./images/diagrams/RCUT.jpg";
import roundaboutDiagram from "./images/diagrams/Roundabout.jpg";
import roundaboutMiniDiagram from "./images/diagrams/RoundaboutMini.jpg";
// import singleLoopDiagram from "./images/diagrams/SingleLoop.png";
import singlePointInterchangeDiagram from "./images/diagrams/SinglePointInterchange.jpg";
import singleRdbtInterchangeDiagram from "./images/diagrams/SingleRdbtInterchange.png";
import splitDiagram from "./images/diagrams/Split.png";
// import thruCutDiagram from "./images/diagrams/ThruCut.png";
import traditionalDiamondDiagram from "./images/diagrams/TraditionalDiamond.jpg";

import ltArrow from "./images/arrow/LTarrow.svg";
import rtArrow from "./images/arrow/RTarrow.svg";
import lt_thruArrow from "./images/arrow/LT_thruarrow.svg";
import rt_thruArrow from "./images/arrow/RT_thruarrow.svg";
import rtCArrow from "./images/arrow/RTArrow_channelized.svg";
import thrArrow from "./images/arrow/Thruarrow.svg";
import utArrow from "./images/arrow/UTarrow.svg";
import enArrow from "./images/arrow/Entryarrow.svg";
import ciArrow from "./images/arrow/Circlingarrow270.svg";
// import ciArrow from "./images/arrow/Circlingarrow180.svg";

import northArrowDg from "./images/other/NorthArrow.JPG";
import northArrowRt90 from "./images/other/NorthArrow_rotate_90.jpg";
import northArrowRt180 from "./images/other/NorthArrow_rotate_180.jpg";
import northArrowRt270 from "./images/other/NorthArrow_rotate_270.JPG";
import cpdLegend from "./images/other/CPDLegend.jpg";
import selectedZone from "./images/other/SelectedZone.svg";
import notSelectedZone from "./images/other/NotSelectedZone.svg";

//conflict point diagrams
import cpdConventional from "./images/conflict-point-diagrams/CPD_Conventional.jpg";
import cpdBowtie from "./images/conflict-point-diagrams/CPD_bowtie.jpg";
import cpdCGT from "./images/conflict-point-diagrams/CPD_CGT.jpg";
import cpdCTO from "./images/conflict-point-diagrams/CPD_CTO.jpg";
import cpdDLTF from "./images/conflict-point-diagrams/CPD_DLT-F.jpg";
import cpdDLTP from "./images/conflict-point-diagrams/CPD_DLT-P.jpg";
import cpdEchelon from "./images/conflict-point-diagrams/CPD_echelon.jpg";
import cpdRBTmini from "./images/conflict-point-diagrams/CPD_miniRBT.jpg";
import cpdMUT from "./images/conflict-point-diagrams/CPD_MUT.jpg";
import cpdPMUT from "./images/conflict-point-diagrams/CPD_PMUT.jpg";
import cpdQR_NE from "./images/conflict-point-diagrams/CPD_QR-NE.jpg";
import cpdQR_NW from "./images/conflict-point-diagrams/CPD_QR-NW.jpg";
import cpdQR_SE from "./images/conflict-point-diagrams/CPD_QR-SE.jpg";
import cpdQR_SW from "./images/conflict-point-diagrams/CPD_QR-SW.jpg";
import cpdRBT from "./images/conflict-point-diagrams/CPD_RBT.jpg";
import cpdRcut from "./images/conflict-point-diagrams/CPD_RCUT.jpg";
import { INTX_TYPES } from "../constants/intxConstants";
// import cpdSingleloop from "./images/conflict-point-diagrams/CPD_singleloop.jpg";
// import cpdThruCut from "./images/conflict-point-diagrams/CPD_ThruCut.jpg";

export const intxImages = {
  bowtie: {
    diagram: bowtieDiagram,
    icon: bowtieIcon,
    conflictDiagram: cpdBowtie,
  },
  centerTurnOverpass: {
    diagram: centerTurnOverpassDiagram,
    icon: centerTurnOverpassIcon,
    conflictDiagram: cpdCTO,
  },
  continuousGreenTN: {
    diagram: continuousGreenTDiagram_N,
    icon: continuousGreenTIcon,
    conflictDiagram: cpdCGT,
  },
  continuousGreenTW: {
    diagram: continuousGreenTDiagram_W,
    icon: continuousGreenTIcon,
    conflictDiagram: cpdCGT,
  },
  continuousGreenTE: {
    diagram: continuousGreenTDiagram_E,
    icon: continuousGreenTIcon,
    conflictDiagram: cpdCGT,
  },
  continuousGreenTS: {
    diagram: continuousGreenTDiagram_S,
    icon: continuousGreenTIcon,
    conflictDiagram: cpdCGT,
  },
  contraflowLeft: {
    diagram: contraflowLeftDiagram,
    icon: contraflowLeftIcon,
    // FIXME:,
    conflictDiagram: cpdConventional,
  },
  conventionalSignal: {
    diagram: conventionalSignalDiagram,
    icon: conventionalSignalIcon,
    conflictDiagram: cpdConventional,
  },
  divergingDiamond: {
    diagram: divergingDiamondDiagram,
    icon: divergingDiamondIcon,
    // FIXME: conflictDiagram: divergingDiamondConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  DLTInterchange: {
    diagram: DLTInterchangeDiagram,
    icon: fullDisplacedLeftTurnIcon,
    conflictDiagram: cpdDLTF,
  },
  doubleRoundabout: {
    diagram: doubleRoundaboutDiagram,
    icon: doubleRoundaboutIcon,
    // FIXME: conflictDiagram: doubleRoundaboutConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  echelon: {
    diagram: echelonDiagram,
    icon: echelonIcon,
    conflictDiagram: cpdEchelon,
  },
  fullDisplacedLeftTurn: {
    diagram: fullDisplacedLeftTurnDiagram,
    icon: fullDisplacedLeftTurnIcon,
    // FIXME: conflictDiagram: fullDisplacedLeftTurnConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  //   michiganUrbanDiamond: {
  //     diagram: michiganUrbanDiamondDiagram,
  //     icon: michiganUrbanDiamondIcon,
  //     // FIXME: conflictDiagram: michiganUrbanDiamondConflictDiagram,
  //     conflictDiagram: cpdConventional,
  //   },
  MUT: {
    diagram: MUTDiagram,
    icon: MUTIcon,
    conflictDiagram: cpdMUT,
  },
  partialCloverleafA: {
    diagram: partialCloverleafADiagram,
    icon: partialCloverleafIcon,
    // FIXME: conflictDiagram: partialCloverleafConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  partialCloverleafB: {
    diagram: partialCloverleafBDiagram,
    icon: partialCloverleafIcon,
    // FIXME: conflictDiagram: partialCloverleafConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  partialDLT: {
    diagram: partialDLTDiagram,
    icon: fullDisplacedLeftTurnIcon,
    conflictDiagram: cpdDLTP,
  },
  partialMUT: {
    diagram: partialMUTDiagram,
    icon: MUTIcon,
    conflictDiagram: cpdPMUT,
  },
  quadrantRoadwayNE: {
    diagram: quadrantRoadwayNEDiagram,
    icon: quadrantRoadwayIcon,
    conflictDiagram: cpdQR_NE,
  },
  quadrantRoadwayNW: {
    diagram: quadrantRoadwayNWDiagram,
    icon: quadrantRoadwayIcon,
    conflictDiagram: cpdQR_NW,
  },
  quadrantRoadwaySE: {
    diagram: quadrantRoadwaySEDiagram,
    icon: quadrantRoadwayIcon,
    conflictDiagram: cpdQR_SE,
  },
  quadrantRoadwaySW: {
    diagram: quadrantRoadwaySWDiagram,
    icon: quadrantRoadwayIcon,
    conflictDiagram: cpdQR_SW,
  },
  RCUT: {
    diagram: RCUTDiagram,
    icon: RCUTIcon,
    conflictDiagram: cpdRcut,
  },
  roundabout: {
    diagram: roundaboutDiagram,
    icon: roundaboutIcon,
    conflictDiagram: cpdRBT,
  },
  roundaboutMini: {
    diagram: roundaboutMiniDiagram,
    icon: roundaboutIcon,
    conflictDiagram: cpdRBTmini,
  },
  //   singleLoop: {
  //     diagram: singleLoopDiagram,
  //     icon: singleLoopIcon,
  //     conflictDiagram: cpdSingleloop,
  //   },
  singlePointInterchange: {
    diagram: singlePointInterchangeDiagram,
    icon: singlePointInterchangeIcon,
    // FIXME: conflictDiagram: singlePointInterchangeConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  singleRdbtInterchange: {
    diagram: singleRdbtInterchangeDiagram,
    icon: singleRdbtInterchangeIcon,
    // FIXME: conflictDiagram: singleRdbtInterchangeConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  split: {
    diagram: splitDiagram,
    icon: splitIcon,
    // FIXME: conflictDiagram: splitConflictDiagram,
    conflictDiagram: cpdConventional,
  },
  //   thruCut: {
  //     diagram: thruCutDiagram,
  //     icon: thruCutIcon,
  //     conflictDiagram: cpdThruCut,
  //   },
  traditionalDiamond: {
    diagram: traditionalDiamondDiagram,
    icon: traditionalDiamondIcon,
    // FIXME: conflictDiagram: traditionalDiamondConflictDiagram,
    conflictDiagram: cpdConventional,
  },
};

export const ArrowMapper = {
  leftArrow: ltArrow,
  thruArrow: thrArrow,
  rightArrow: rtArrow,
  rightArrow_channelized: rtCArrow,
  leftThruArrow: lt_thruArrow,
  rightThruArrow: rt_thruArrow,
  uturnArrow: utArrow,
  entryArrow: enArrow,
  circArrow: ciArrow,
};

export const OtherImgMapper = {
  northArrowDg,
  northArrowRt90,
  northArrowRt180,
  northArrowRt270,
  cpdLegend,
  selectedZone,
  notSelectedZone,
};

export const IntxIconMapper = {
  // At-Grade Signalized Intersections
  [INTX_TYPES.SIGNAL]: intxImages.conventionalSignal.icon,
  [INTX_TYPES.BOWTIE]: intxImages.bowtie.icon,
  [INTX_TYPES.CTO]: intxImages.centerTurnOverpass.icon,
  [INTX_TYPES.CGT_N]: intxImages.continuousGreenTN.icon,
  [INTX_TYPES.CGT_W]: intxImages.continuousGreenTW.icon,
  [INTX_TYPES.CGT_E]: intxImages.continuousGreenTE.icon,
  [INTX_TYPES.CGT_S]: intxImages.continuousGreenTS.icon,
  [INTX_TYPES.CGT]: intxImages.continuousGreenTN.icon,
  [INTX_TYPES.DLT]: intxImages.partialDLT.icon,
  [INTX_TYPES.ECHELON]: intxImages.echelon.icon,
  [INTX_TYPES.FDLT]: intxImages.fullDisplacedLeftTurn.icon,
  [INTX_TYPES.JUGHANDLE]: intxImages.conventionalSignal.icon,
  [INTX_TYPES.MUT]: intxImages.MUT.icon,
  [INTX_TYPES.PDLT]: intxImages.partialDLT.icon,
  [INTX_TYPES.PMUT]: intxImages.partialMUT.icon,
  [INTX_TYPES.QR_NE]: intxImages.quadrantRoadwayNE.icon,
  [INTX_TYPES.QR_NW]: intxImages.quadrantRoadwayNW.icon,
  [INTX_TYPES.QR_SE]: intxImages.quadrantRoadwaySE.icon,
  [INTX_TYPES.QR_SW]: intxImages.quadrantRoadwaySW.icon,
  [INTX_TYPES.QUADRANT_ROADWAY]: intxImages.quadrantRoadwaySW.icon,
  [INTX_TYPES.RCUT_SIGNALIZED]: intxImages.RCUT.icon,
  [INTX_TYPES.SPLIT_INTX]: intxImages.split.icon,

  // At-Grade Unsignalized
  [INTX_TYPES.ONE_LANE_ROUNDABOUT]: intxImages.roundaboutMini.icon,
  [INTX_TYPES.TWO_LANE_ROUNDABOUT]: intxImages.roundabout.icon,
  [INTX_TYPES.MINI_RBT_50]: intxImages.roundaboutMini.icon,
  [INTX_TYPES.MINI_RBT_75]: intxImages.roundaboutMini.icon,
  [INTX_TYPES.RCUT_UNSIGNALIZED]: intxImages.RCUT.icon,
  [INTX_TYPES.ROUNDABOUT]: intxImages.roundabout.icon,
  [INTX_TYPES.ALL_WAY_STOP]: intxImages.conventionalSignal.icon,
  [INTX_TYPES.TWSC]: intxImages.conventionalSignal.icon,

  // Grade Separated Interchanges
  [INTX_TYPES.TRAD_DIAMOND]: intxImages.traditionalDiamond.icon,
  [INTX_TYPES.DIAMOND_WITH_SIGNALS]: intxImages.traditionalDiamond.icon,
  [INTX_TYPES.DIAMOND_WITH_STOP_CONTROL]: intxImages.traditionalDiamond.icon,
  [INTX_TYPES.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.icon,
  [INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.icon,
  [INTX_TYPES.CONTRAFLOW_LEFT]: intxImages.contraflowLeft.icon,
  [INTX_TYPES.DLT_INTERCHANGE]: intxImages.DLTInterchange.icon,
  [INTX_TYPES.DDI]: intxImages.divergingDiamond.icon,
  [INTX_TYPES.DOUBLE_RBT]: intxImages.doubleRoundabout.icon,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_A]: intxImages.partialCloverleafA.icon,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_B]: intxImages.partialCloverleafB.icon,
  [INTX_TYPES.SINGLE_POINT_DIAMOND]: intxImages.singlePointInterchange.icon,
  [INTX_TYPES.SINGLE_RBT]: intxImages.singleRdbtInterchange.icon,

  // other
  [INTX_TYPES.OTHER]: intxImages.conventionalSignal.icon,
};

export const IntxDiagramMapper = {
  // At-Grade Signalized Intersections
  [INTX_TYPES.SIGNAL]: intxImages.conventionalSignal.diagram,
  [INTX_TYPES.BOWTIE]: intxImages.bowtie.diagram,
  [INTX_TYPES.CTO]: intxImages.centerTurnOverpass.diagram,
  [INTX_TYPES.CGT_N]: intxImages.continuousGreenTN.diagram,
  [INTX_TYPES.CGT_W]: intxImages.continuousGreenTW.diagram,
  [INTX_TYPES.CGT_E]: intxImages.continuousGreenTE.diagram,
  [INTX_TYPES.CGT_S]: intxImages.continuousGreenTS.diagram,
  [INTX_TYPES.CGT]: intxImages.continuousGreenTN.diagram,
  [INTX_TYPES.DLT]: intxImages.partialDLT.diagram,
  [INTX_TYPES.ECHELON]: intxImages.echelon.diagram,
  [INTX_TYPES.FDLT]: intxImages.fullDisplacedLeftTurn.diagram,
  [INTX_TYPES.JUGHANDLE]: intxImages.conventionalSignal.diagram,
  [INTX_TYPES.MUT]: intxImages.MUT.diagram,
  [INTX_TYPES.PDLT]: intxImages.partialDLT.diagram,
  [INTX_TYPES.PMUT]: intxImages.partialMUT.diagram,
  [INTX_TYPES.QR_NE]: intxImages.quadrantRoadwayNE.diagram,
  [INTX_TYPES.QR_NW]: intxImages.quadrantRoadwayNW.diagram,
  [INTX_TYPES.QR_SE]: intxImages.quadrantRoadwaySE.diagram,
  [INTX_TYPES.QR_SW]: intxImages.quadrantRoadwaySW.diagram,
  [INTX_TYPES.QUADRANT_ROADWAY]: intxImages.quadrantRoadwaySW.diagram,
  [INTX_TYPES.RCUT_SIGNALIZED]: intxImages.RCUT.diagram,
  [INTX_TYPES.RCUT_UNSIGNALIZED]: intxImages.RCUT.diagram,
  [INTX_TYPES.SPLIT_INTX]: intxImages.split.diagram,

  // At-Grade Unsignalized
  [INTX_TYPES.ONE_LANE_ROUNDABOUT]: intxImages.roundaboutMini.diagram,
  [INTX_TYPES.TWO_LANE_ROUNDABOUT]: intxImages.roundabout.diagram,
  [INTX_TYPES.MINI_RBT_50]: intxImages.roundaboutMini.diagram,
  [INTX_TYPES.MINI_RBT_75]: intxImages.roundaboutMini.diagram,
  [INTX_TYPES.ROUNDABOUT]: intxImages.roundabout.diagram,
  [INTX_TYPES.ALL_WAY_STOP]: intxImages.conventionalSignal.diagram,
  [INTX_TYPES.TWSC]: intxImages.conventionalSignal.diagram,

  // Grade Separated Interchanges
  [INTX_TYPES.TRAD_DIAMOND]: intxImages.traditionalDiamond.diagram,
  [INTX_TYPES.DIAMOND_WITH_SIGNALS]: intxImages.traditionalDiamond.diagram,
  [INTX_TYPES.DIAMOND_WITH_STOP_CONTROL]: intxImages.traditionalDiamond.diagram,
  [INTX_TYPES.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.diagram,
  [INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.diagram,
  [INTX_TYPES.CONTRAFLOW_LEFT]: intxImages.contraflowLeft.diagram,
  [INTX_TYPES.DLT_INTERCHANGE]: intxImages.DLTInterchange.diagram,
  [INTX_TYPES.DDI]: intxImages.divergingDiamond.diagram,
  [INTX_TYPES.DOUBLE_RBT]: intxImages.doubleRoundabout.diagram,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_A]: intxImages.partialCloverleafA.diagram,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_B]: intxImages.partialCloverleafB.diagram,
  [INTX_TYPES.SINGLE_POINT_DIAMOND]: intxImages.singlePointInterchange.diagram,
  [INTX_TYPES.SINGLE_RBT]: intxImages.singleRdbtInterchange.diagram,

  // other
  [INTX_TYPES.OTHER]: intxImages.conventionalSignal.diagram,
};

export const ConflictPointDiagramMapper = {
  // At-Grade Signalized Intersections
  [INTX_TYPES.SIGNAL]: intxImages.conventionalSignal.conflictDiagram,
  [INTX_TYPES.BOWTIE]: intxImages.bowtie.conflictDiagram,
  [INTX_TYPES.CTO]: intxImages.centerTurnOverpass.conflictDiagram,
  [INTX_TYPES.CGT_N]: intxImages.continuousGreenTN.conflictDiagram,
  [INTX_TYPES.CGT_W]: intxImages.continuousGreenTW.conflictDiagram,
  [INTX_TYPES.CGT_E]: intxImages.continuousGreenTE.conflictDiagram,
  [INTX_TYPES.CGT_S]: intxImages.continuousGreenTS.conflictDiagram,
  [INTX_TYPES.DLT]: intxImages.partialDLT.conflictDiagram,
  [INTX_TYPES.ECHELON]: intxImages.echelon.conflictDiagram,
  [INTX_TYPES.FDLT]: intxImages.DLTInterchange.conflictDiagram,
  [INTX_TYPES.JUGHANDLE]: intxImages.conventionalSignal.conflictDiagram,
  [INTX_TYPES.MUT]: intxImages.MUT.conflictDiagram,
  [INTX_TYPES.PDLT]: intxImages.partialDLT.conflictDiagram,
  [INTX_TYPES.PMUT]: intxImages.partialMUT.conflictDiagram,
  [INTX_TYPES.QR_NE]: intxImages.quadrantRoadwayNE.conflictDiagram,
  [INTX_TYPES.QR_NW]: intxImages.quadrantRoadwayNW.conflictDiagram,
  [INTX_TYPES.QR_SE]: intxImages.quadrantRoadwaySE.conflictDiagram,
  [INTX_TYPES.QR_SW]: intxImages.quadrantRoadwaySW.conflictDiagram,
  [INTX_TYPES.QUADRANT_ROADWAY]: intxImages.quadrantRoadwaySW.conflictDiagram,
  [INTX_TYPES.RCUT_SIGNALIZED]: intxImages.RCUT.conflictDiagram,
  [INTX_TYPES.RCUT_UNSIGNALIZED]: intxImages.RCUT.conflictDiagram,
  [INTX_TYPES.SPLIT_INTX]: intxImages.split.conflictDiagram,

  // At-Grade Unsignalized
  [INTX_TYPES.ONE_LANE_ROUNDABOUT]: intxImages.roundaboutMini.conflictDiagram,
  [INTX_TYPES.TWO_LANE_ROUNDABOUT]: intxImages.roundabout.conflictDiagram,
  [INTX_TYPES.MINI_RBT_50]: intxImages.roundaboutMini.conflictDiagram,
  [INTX_TYPES.MINI_RBT_75]: intxImages.roundaboutMini.conflictDiagram,
  [INTX_TYPES.ROUNDABOUT]: intxImages.roundabout.conflictDiagram,
  [INTX_TYPES.ALL_WAY_STOP]: intxImages.conventionalSignal.conflictDiagram,
  [INTX_TYPES.TWSC]: intxImages.conventionalSignal.conflictDiagram,

  // Grade Separated Interchanges
  [INTX_TYPES.TRAD_DIAMOND]: intxImages.traditionalDiamond.conflictDiagram,
  [INTX_TYPES.DIAMOND_WITH_SIGNALS]:
    intxImages.traditionalDiamond.conflictDiagram,
  [INTX_TYPES.DIAMOND_WITH_STOP_CONTROL]:
    intxImages.traditionalDiamond.conflictDiagram,
  [INTX_TYPES.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.conflictDiagram,
  [INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS]:
    intxImages.doubleRoundabout.conflictDiagram,
  [INTX_TYPES.CONTRAFLOW_LEFT]: intxImages.contraflowLeft.conflictDiagram,
  [INTX_TYPES.DLT_INTERCHANGE]: intxImages.DLTInterchange.conflictDiagram,
  [INTX_TYPES.DDI]: intxImages.divergingDiamond.conflictDiagram,
  [INTX_TYPES.DOUBLE_RBT]: intxImages.doubleRoundabout.conflictDiagram,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_A]:
    intxImages.partialCloverleafA.conflictDiagram,
  [INTX_TYPES.PARTIAL_CLOVERLEAF_B]:
    intxImages.partialCloverleafB.conflictDiagram,
  [INTX_TYPES.SINGLE_POINT_DIAMOND]:
    intxImages.singlePointInterchange.conflictDiagram,
  [INTX_TYPES.SINGLE_RBT]: intxImages.singleRdbtInterchange.conflictDiagram,

  // other
  [INTX_TYPES.OTHER]: intxImages.conventionalSignal.conflictDiagram,
};
